<template>
  <Playable
    :src="mgnlProps.src"
    :width="mgnlProps.width"
    :height="mgnlProps.height"
    :is-pop-up="mgnlProps.isPopUp"
    :open-after-seconds="mgnlProps.openAfterSeconds"
  />
</template>

<script lang="ts" setup>
import { PlayableBuilder, WrapperProps } from './Playable.model';
import Playable from './Playable.vue';

const props = defineProps(WrapperProps);
const mgnlProps = computed(() => PlayableBuilder.build(props));
</script>
